function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { compact } from 'lodash-es';
import { TableList, Typography, DropdownMenu, TableListActions, WithInfoIcon, Tooltip } from 'seagull';
import { ActivityLiner24, CopyLiner24, DownloadLiner24, Edit1Liner24, EmptyWalletTickLiner24, LinkLiner24, ProfileLiner24, ProposalLiner24, ReceiptEditLiner24, TrashLiner24 } from 'seagull/icons';
import { routes } from "../../constants";
import { Intent } from "../../infra/access-control";
import styles from "./AgreementsDashboardRow.module.scss";
import { relationshipModel, relationshipSummaryModel, timeModel } from "../../models";
import EnterAccountantAccessButton from "../../components/EnterAccountantAccessButton/EnterAccountantAccessButton";
import ShareAgreementLinksModal from "./ShareAgreementLinksModal";
import { useOverlayContext } from 'seagull';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const agreementStatusToText = {
  [relationshipSummaryModel.AgreementStatus.Active]: 'Active',
  [relationshipSummaryModel.AgreementStatus.Exhausted]: 'Completed',
  [relationshipSummaryModel.AgreementStatus.Terminated]: 'Terminated'
};
export default function AgreementsDashboardRow(props) {
  const {
    isVendor,
    index,
    hasAccountantAccess,
    onVerifyPaymentMethod,
    onEditAgreement,
    onDownloadPDF,
    onDuplicateAgreement,
    onTerminateAgreement,
    onEnterAccountantAccess,
    onRenameAgreement,
    onChangeAssignee
  } = props;
  const [agreement, setAgreement] = useState(props.agreement);
  useEffect(() => setAgreement(props.agreement), [props.agreement]);
  const overlayContext = useOverlayContext();
  const history = useHistory();
  const displayedTitle = relationshipSummaryModel.displayedTitle(agreement, isVendor);
  const testId = agreement.isSample ? 'test-agreement' : "agreements-row-".concat(index);
  const heapId = agreement.isSample ? 'test-agreement' : 'agreement';
  const isTerminated = relationshipSummaryModel.isTerminated(agreement);
  const canCompleteVerification = relationshipSummaryModel.canCompleteVerification(agreement);
  const agreementStatus = relationshipSummaryModel.agreementStatus(agreement);
  const canRequestPM = (!agreement.fundingSource || agreement.fundingSource.failedVerification()) && !relationshipSummaryModel.isTerminated(agreement) && isVendor;
  const agreementLink = isVendor || !relationshipModel.isPending(agreement) ? routes.agreement(agreement.id) : routes.clientOnboarding(agreement.id);
  const items = compact([{
    value: /*#__PURE__*/_jsxs("div", {
      className: styles.title,
      children: [/*#__PURE__*/_jsxs(Typography, {
        ellipsis: true,
        hideTooltip: true,
        children: [/*#__PURE__*/_jsx(Typography, {
          ellipsis: true,
          weight: "normal",
          "data-testid": "".concat(testId, "-company-name"),
          tooltipTestId: "".concat(testId, "-company-name-tooltip"),
          children: relationshipSummaryModel.opposingPartyName(agreement, isVendor)
        }), displayedTitle && /*#__PURE__*/_jsx(Typography, {
          ellipsis: true,
          variant: "paragraph2",
          skin: "secondary",
          "data-testid": "".concat(testId, "-title"),
          tooltipTestId: "".concat(testId, "-title-tooltip"),
          children: displayedTitle
        })]
      }), hasAccountantAccess && /*#__PURE__*/_jsx(EnterAccountantAccessButton, {
        testid: "".concat(testId, "-enter-acc-access"),
        onClick: e => {
          e.stopPropagation(); // Prevents the row <button> element from redirecting to its target.
          onEnterAccountantAccess(relationshipSummaryModel.customerBusinessId(agreement), relationshipSummaryModel.customerBusinessName(agreement));
        }
      })]
    })
  }, {
    value: /*#__PURE__*/_jsxs("div", {
      className: styles.status,
      children: [/*#__PURE__*/_jsx(WithInfoIcon, {
        showInfo: agreementStatus === relationshipSummaryModel.AgreementStatus.Exhausted,
        info: "All services in this agreement were completed",
        infoTestId: "".concat(testId, "-status-info"),
        children: /*#__PURE__*/_jsx(Typography, {
          skin: "secondary",
          "data-testid": "".concat(testId, "-status"),
          children: agreementStatusToText[agreementStatus]
        })
      }), agreement.hasAmendments && /*#__PURE__*/_jsx(Tooltip, {
        placement: "top",
        title: "Agreement has changes awaiting approval.",
        children: /*#__PURE__*/_jsx(Typography, {
          "data-testid": "".concat(testId, "-has-amendments"),
          children: /*#__PURE__*/_jsx(ReceiptEditLiner24, {
            size: 16
          })
        })
      })]
    })
  }, isVendor && {
    value: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      skin: "secondary",
      "data-testid": "".concat(testId, "-assignee"),
      children: relationshipSummaryModel.sellerFullName(agreement)
    })
  }, {
    value: /*#__PURE__*/_jsx(Typography, {
      skin: "secondary",
      children: agreement.effectiveDate ? timeModel.formatDateLong(agreement.effectiveDate) : ''
    })
  }, {
    value: !agreement.fundingSource ? /*#__PURE__*/_jsx(Typography, {
      skin: "error",
      children: "Not set"
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Typography, {
        skin: "secondary",
        children: [agreement.fundingSource.isCreditCard() ? 'Credit card' : 'Bank account', " (", agreement.fundingSource.last4(), ")"]
      }), agreement.fundingSource.failedVerification() && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph2",
        skin: "error",
        children: "Verification failed"
      }), agreement.fundingSource.isPendingMicroDeposit() && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph2",
        skin: "warning",
        children: agreement.fundingSource.isPendingAutomaticVerification() ? 'Automatic verification initiated' : 'Manual verification initiated'
      })]
    })
  }, {
    value: agreement.lastBilledDate ? /*#__PURE__*/_jsx(Typography, {
      skin: "secondary",
      "data-testid": "".concat(testId, "-last-billed"),
      children: timeModel.formatDateLong(agreement.lastBilledDate)
    }) : null
  }]);
  const getButtonText = () => {
    if (canCompleteVerification) return 'Complete verification';
    return canRequestPM ? 'Add payment method' : undefined;
  };
  const onButtonClick = () => {
    if (canCompleteVerification) {
      onVerifyPaymentMethod(agreement);
    } else {
      history.push(routes.paymentMethods(agreement.id));
    }
  };
  return /*#__PURE__*/_jsx(TableList.Row, {
    onClick: () => history.push(agreementLink),
    items: items,
    rowId: agreement.id,
    "data-testid": testId,
    "data-heapid": heapId,
    actionColumn: /*#__PURE__*/_jsxs(TableListActions, {
      testId: testId,
      menuHeapId: "".concat(heapId, "-menu-btn"),
      buttonText: getButtonText(),
      secondaryButtonText: "View",
      secondaryBtnHeapId: "".concat(heapId, "-view-btn"),
      onClickButton: onButtonClick,
      onClickSecondaryButton: () => history.push(agreementLink),
      children: [isVendor && !isTerminated && /*#__PURE__*/_jsx(DropdownMenu.Item, {
        iconStart: /*#__PURE__*/_jsx(ReceiptEditLiner24, {}),
        disabled: agreement.isSample,
        "data-testid": "".concat(testId, "-edit-agreement"),
        onClick: () => onEditAgreement(agreement),
        children: "Edit agreement"
      }), isVendor && /*#__PURE__*/_jsx(DropdownMenu.Item, {
        iconStart: /*#__PURE__*/_jsx(Edit1Liner24, {}),
        disabled: agreement.isSample,
        "data-testid": "".concat(testId, "-rename-agreement"),
        onClick: () => onRenameAgreement(agreement, title => {
          const newAgreement = relationshipSummaryModel.setTitle(agreement, title);
          setAgreement(newAgreement);
        }),
        children: "Rename agreement"
      }), isVendor && /*#__PURE__*/_jsx(DropdownMenu.Item, {
        iconStart: /*#__PURE__*/_jsx(ProfileLiner24, {}),
        "data-testid": "".concat(testId, "-change-assignee"),
        onClick: () => onChangeAssignee(agreement),
        children: "Change assignee"
      }), isVendor && /*#__PURE__*/_jsx(DropdownMenu.Item, {
        intent: Intent.DuplicateAgreement,
        iconStart: /*#__PURE__*/_jsx(CopyLiner24, {}),
        disabled: agreement.isSample,
        "data-testid": "".concat(testId, "-duplicate"),
        "data-heapid": "".concat(heapId, "-menu-duplicate"),
        onClick: () => onDuplicateAgreement(agreement),
        children: "Duplicate agreement"
      }), /*#__PURE__*/_jsx(DropdownMenu.Item, {
        intent: Intent.DownloadAgreementPdf,
        iconStart: /*#__PURE__*/_jsx(DownloadLiner24, {}),
        "data-testid": "".concat(testId, "-download-pdf"),
        "data-heapid": "".concat(heapId, "-menu-download-pdf"),
        onClick: () => onDownloadPDF(agreement),
        children: "Download PDF"
      }), /*#__PURE__*/_jsx(DropdownMenu.Item, {
        iconStart: /*#__PURE__*/_jsx(LinkLiner24, {}),
        "data-testid": "".concat(testId, "-direct-links"),
        onClick: () => {
          overlayContext.showModal({
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: p => /*#__PURE__*/_jsx(ShareAgreementLinksModal, _objectSpread(_objectSpread({}, p), {}, {
              relationship: agreement
            }))
          });
        },
        children: "Share direct link"
      }), !isTerminated && /*#__PURE__*/_jsx(DropdownMenu.Item, {
        as: Link,
        to: routes.billingHub(agreement.id),
        iconStart: /*#__PURE__*/_jsx(EmptyWalletTickLiner24, {}),
        disabled: agreement.isSample,
        "data-testid": "".concat(testId, "-billing-hub"),
        "data-heapid": "".concat(heapId, "-menu-billing-hub"),
        children: "Manage billing"
      }), !isTerminated && /*#__PURE__*/_jsx(DropdownMenu.Item, {
        as: Link,
        to: routes.invoices(agreement.id),
        iconStart: /*#__PURE__*/_jsx(ProposalLiner24, {}),
        disabled: agreement.isSample,
        "data-testid": "".concat(testId, "-invoices"),
        "data-heapid": "".concat(heapId, "-menu-invoices"),
        children: "View invoices"
      }), /*#__PURE__*/_jsx(DropdownMenu.Item, {
        as: Link,
        to: routes.activityLog(agreement.id),
        iconStart: /*#__PURE__*/_jsx(ActivityLiner24, {}),
        disabled: agreement.isSample,
        "data-testid": "".concat(testId, "-activity"),
        "data-heapid": "".concat(heapId, "-menu-activity"),
        children: "View activity log"
      }), isVendor && !isTerminated && /*#__PURE__*/_jsx(DropdownMenu.Item, {
        intent: Intent.TerminateAgreement,
        skin: "error",
        iconStart: /*#__PURE__*/_jsx(TrashLiner24, {}),
        "data-testid": "".concat(testId, "-terminate"),
        "data-heapid": "".concat(heapId, "-menu-terminate"),
        onClick: () => onTerminateAgreement(agreement),
        children: "Terminate agreement"
      })]
    })
  });
}